import { Redirect } from 'react-router';
import Navigate from 'src/helpers/Navigate';

// Stored links to a retired page land on the common sunset page (PFM-1426).
const RedirectToSunset = () => <Redirect to={Navigate.link.toSunset()} />;

// Route entry for a retired URL: hidden from every menu, cut off from the parent's header actions,
// and rendering the sunset redirect. It keeps the page's permission and preference gates, so a user
// who could not open the page still gets PageNotFound rather than learning it existed.
export const retiredRoute = (route, { requirePermission, requirePreference, routes } = {}) => ({
  route,
  requirePermission,
  requirePreference,
  routes,
  hidden: true,
  overrideActions: true,
  component: RedirectToSunset
});

export default RedirectToSunset;
